export enum TransferType {
  Purchase = 0,
  ForcedSale = 1,
  Renunciation = 2,
  Gift = 10,
  Inheritance = 11,
  PartitionOfProperty = 12,
}

export function transferTypeToString(transferType: TransferType): string {
  switch (transferType) {
    case TransferType.ForcedSale:
      return 'COOPERATIVE_HOUSING.TRANSFER_TYPES.FORCED';
    case TransferType.Gift:
      return 'COOPERATIVE_HOUSING.TRANSFER_TYPES.GIFT';
    case TransferType.Inheritance:
      return 'COOPERATIVE_HOUSING.TRANSFER_TYPES.INHERITENCE';
    case TransferType.PartitionOfProperty:
      return 'COOPERATIVE_HOUSING.TRANSFER_TYPES.PARTITION_OF_PROPERTY';
    case TransferType.Purchase:
      return 'COOPERATIVE_HOUSING.TRANSFER_TYPES.PURCHASE';
    case TransferType.Renunciation:
      return 'COOPERATIVE_HOUSING.TRANSFER_TYPES.RENUNCIATION';
    default:
      return '';
  }
}
